import { render } from "./CapAlert.vue?vue&type=template&id=f52e070e&scoped=true"
import script from "./CapAlert.vue?vue&type=script&lang=js"
export * from "./CapAlert.vue?vue&type=script&lang=js"

import "./CapAlert.vue?vue&type=style&index=0&id=f52e070e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f52e070e"]])

export default __exports__